import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AliasStatusEnum } from 'modules/CreateNewRoomModal/CreateNewRoomDataProvider/utils';
import testingConstants from 'utils/testingConstants';

import AliasAvailable from './AliasAvailable';
import AliasInput from './AliasInput';
import AliasNotAvailable from './AliasNotAvailable';
import useAliasField from './useAliasField';
import useCreateNewRoomDataContext from '../../CreateNewRoomDataProvider/useCreateNewRoomDataContext';

const AliasField = () => {
  const { t } = useTranslation();
  const { roomForm, digitsPostfix } = useCreateNewRoomDataContext();
  const { onAliasChange, AliasIcon, onAliasIconClick, aliasStatus, isAliasCheckLoading } = useAliasField();

  const {
    getValues,
    getFieldState,
    control,
    formState: { errors },
  } = roomForm;

  const roomNameDashedTranslation = t('room_name').toLowerCase().split(' ').join('-');
  const roomAliasValue = `${getValues('roomAlias') || roomNameDashedTranslation}-${digitsPostfix}`;
  const isAliasAndTitleValid = !getFieldState('roomAlias').invalid || !getFieldState('roomName').invalid;
  const hasError = aliasStatus === AliasStatusEnum.UNAVAILABLE || !!errors.roomAlias?.message;

  const AliasAvailabilityComponent =
    isAliasAndTitleValid && !isAliasCheckLoading && aliasStatus === AliasStatusEnum.UNAVAILABLE ? (
      <AliasNotAvailable alias={roomAliasValue} />
    ) : isAliasAndTitleValid ? (
      <AliasAvailable alias={roomAliasValue} />
    ) : null;

  return (
    <Controller
      name="roomAlias"
      control={control}
      render={({ field: { onChange, value } }) => (
        <AliasInput
          value={value}
          postfix={digitsPostfix}
          onChange={onAliasChange(onChange)}
          hasError={hasError}
          placeholder={roomNameDashedTranslation}
          AliasIcon={AliasIcon}
          onAliasIconClick={onAliasIconClick}
          isAliasCheckLoading={isAliasCheckLoading}
          AliasAvailabilityComponent={AliasAvailabilityComponent}
          errorMessage={errors.roomAlias?.message}
          dataTestId={testingConstants.roomAlias}
          hintText={t('room_alias_explanation')}
        />
      )}
    />
  );
};

export default AliasField;
